module.exports = __webpack_public_path__ + "static/img/ygbj1.808feaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/ygbj1.png
// module id = E8ly
// module chunks = 0